/** The drifting leaves and sparkles of the entry pages (design: index/apply/signed-out .fall), decorative only. */
const LEAVES: [string, string, string, string, string, string][] = [
  ['8%', '22px', 'var(--fall-amber)', '17s', '0s', '40px'],
  ['24%', '16px', 'var(--fall-olive)', '21s', '-8s', '-30px'],
  ['44%', '26px', 'var(--cw-rose-ink)', '19s', '-3s', '50px'],
  ['63%', '18px', 'var(--fall-amber)', '23s', '-14s', '-45px'],
  ['80%', '24px', 'var(--fall-olive)', '18s', '-6s', '35px'],
  ['93%', '15px', 'var(--cw-rose-ink)', '25s', '-11s', '-35px'],
]
const SPARKS: [string, string, string, string][] = [['12%', '30%', '20px', '0s'], ['88%', '22%', '26px', '-2s'], ['72%', '60%', '16px', '-3.5s']]

export function Falling() {
  return (
    <div className="fall" aria-hidden="true">
      {LEAVES.map(([x, s, c, d, delay, sway], i) => (
        <span key={`l${i}`} className="leaf" style={{ '--x': x, '--s': s, '--c': c, '--d': d, '--delay': delay, '--sway': sway } as React.CSSProperties}><svg><use href="#s-leaf" /></svg></span>
      ))}
      {SPARKS.map(([x, y, s, delay], i) => (
        <span key={`s${i}`} className="spark" style={{ '--x': x, '--y': y, '--s': s, '--delay': delay } as React.CSSProperties}><svg><use href="#s-spark" /></svg></span>
      ))}
    </div>
  )
}
